import { api } from "../AxiosInstance";

interface UpdateTruckRequest {
  driverId: number;
  oldTruckNumber: string;
  newTruckNumber: string;
  trailerContainerType?: string; // Optional for new trucks
  trailerCapacity?: string; // Optional for new trucks
}

const TruckService = {
  updateTruck: async (request: UpdateTruckRequest) => {
    try {
      const response = await api.put("/driver/update-truck", request);
      return response;
    } catch (error) {
      console.error("Error updating truck:", error);
      throw error;
    }
  },
};

export default TruckService;
